<script setup lang="ts">
import { computed } from 'vue'
import useTab from '../../Composables/useTab'
import BlockContent from '../UI/Content/BlockContent.vue'
import type { Tab } from '../../../../Types/tab'

interface Props {
  modelValue: Tab | null
  tabs: Tab[]
  boxShadow?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  boxShadow: true,
})
const emit = defineEmits<{
  'update:modelValue': [tab: Tab]
}>()

const { tabsShown, setActiveTab } = useTab({
  tabs: computed(() => props.tabs),
  modelValue: computed(() => props.modelValue),
  onTabChange: (tab: Tab) => emit('update:modelValue', tab),
})

const isVisible = computed(() => tabsShown.value.length > 1)

function getTabClasses(value: Tab) {
  return {
    'sub-active': value.key === props.modelValue?.key,
    'ml-1': props.tabs.findIndex(({ key }) => key === value.key) > 0,
  }
}
</script>

<template>
  <BlockContent v-if="isVisible" :box-shadow="boxShadow">
    <div class="submenu-link">
      <a
        v-for="(tab, index) in tabsShown"
        :key="tab.key"
        :class="getTabClasses(tab)"
        :tabindex="index"
        @click="setActiveTab(tab)"
      >
        {{ tab.title }}
      </a>
    </div>
  </BlockContent>
</template>
